import styled, { css } from 'styled-components';
import { MozartTable } from '@pgforsta/mozart_ui';

const TableWrapper = styled.div`
  div[data-theme='MozartTable'] {
    table {
      ${(props) =>
        props.stickyHeaders &&
        css`
          position: relative;
        `}
    }

    thead tr,
    tbody tr:last-of-type {
      border-bottom: none !important;
    }

    thead tr th {
      background-color: #f5f4fe;

      ${(props) =>
        props.stickyHeaders &&
        css`
          position: sticky;
          top: 0;
          z-index: 1;
        `}
    }

    ${(props) =>
      props.alternateRows &&
      css`
        tbody tr:nth-child(2n) td {
          background-color: #f5f4fe;
        }
      `}

    tr {
      border-bottom: 1px solid #d9d5f9 !important;
    }
  }
`;

const defaultStyles = { marginTop: '0' };

const defaultHeadStyles = {
  padding: '15px 10px',
  color: '#3e3a83',
  fontSize: '14px',
  fontWeight: 400,
  textAlign: 'left',
};

const defaultRowStyles = { borderBottom: 'none' };

const defaultColStyles = {
  padding: '15px 10px',
  color: '#3e3a83',
  fontSize: '14px',
  fontWeight: 400,
  textAlign: 'left',
};

const Table = ({
  id,
  headers,
  rows,
  style = defaultStyles,
  headStyle = defaultHeadStyles,
  rowStyle = defaultRowStyles,
  colStyle = defaultColStyles,
  alternateRows = true,
  stickyHeaders = false,
}) => (
  <TableWrapper alternateRows={alternateRows} stickyHeaders={stickyHeaders}>
    <MozartTable
      id={id}
      theme="classic"
      style={style}
      headStyle={headStyle}
      rowStyle={rowStyle}
      colStyle={colStyle}
      headers={headers}
      rows={rows}
    />
  </TableWrapper>
);

export default Table;
